export const workspaceStrings = {
  overviewLabel: (hobbyName) => `Go to ${hobbyName} overview`,
  comingSoon: (hobbyName) => `${hobbyName} module is coming soon!`,
  moduleLoadFailed: 'We could not load this hobby module.',
};
